import script from "./FormField.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormField.vue?vue&type=script&setup=true&lang=ts"

import "./FormField.vue?vue&type=style&index=0&id=56970949&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56970949"]])

export default __exports__